(function () {
  "use strict";

  var MOBILE_MQ = "(max-width: 1023px)";
  var ROOT = "[js-trust-bar]";

  function initTrustBar(viewport) {
    if (!viewport || viewport.dataset.trustBarInit === "true") return;
    viewport.dataset.trustBarInit = "true";

    var track = viewport.querySelector(".trust-bar__track");
    if (!track) return;

    function syncPaused(paused) {
      track.classList.toggle("is-paused", paused);
    }

    viewport.addEventListener("pointerenter", function () {
      if (window.matchMedia(MOBILE_MQ).matches) syncPaused(true);
    });
    viewport.addEventListener("pointerleave", function () {
      syncPaused(false);
    });

    viewport.addEventListener("focusin", function () {
      if (window.matchMedia(MOBILE_MQ).matches) syncPaused(true);
    });
    viewport.addEventListener("focusout", function (event) {
      if (!viewport.contains(event.relatedTarget)) syncPaused(false);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(initTrustBar);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector(ROOT);
    if (root) initTrustBar(root);
  });
})();
